import { NavLink } from 'react-router-dom';
import { Calculator, LineChart, BookOpen, FileText, Settings, type LucideIcon } from 'lucide-react';

const TABS: { to: string; label: string; icon: LucideIcon }[] = [
  { to: '/', label: 'Calculator', icon: Calculator },
  { to: '/levels', label: 'Levels', icon: LineChart },
  { to: '/reference', label: 'Reference', icon: BookOpen },
  { to: '/docs', label: 'Docs', icon: FileText },
  { to: '/settings', label: 'Settings', icon: Settings },
];

/** Bottom tab bar on mobile; horizontal under header on desktop. */
export function TabBar(): JSX.Element {
  return (
    <nav className="tabbar" aria-label="Primary navigation">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => `tabbar-item${isActive ? ' active' : ''}`}
            end={tab.to === '/'}
          >
            <span className="tabbar-icon" aria-hidden="true">
              <Icon size={20} strokeWidth={2} />
            </span>
            <span className="tabbar-label">{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
